import type { SVGProps } from 'react';

export const SvgImgIllustWater = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 204 173" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.001 160.422L2 102.687L101.999 44.9515L202 102.687L102.001 160.422Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M2 112.77V102.686L102.001 160.421V170.506L2 112.77Z"
      fill="url(#paint0_linear_4444_1871)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M201.999 102.686V112.772L102 170.506V160.422L201.999 102.686Z"
      fill="url(#paint1_linear_4444_1871)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M96.3437 68.8638L96.3364 81.5512L128.314 63.1955L128.233 53.485L96.3437 68.8638Z"
      fill="#E72125"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M70.2466 58.18L70.2538 31.4863L102.154 49.8841L102.227 74.7473L96.3359 71.4095V81.5505L102.174 84.9259L102.227 102.538L70.3335 84.0027L70.2538 58.1815L70.2466 58.18Z"
      fill="#D8D8D8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M102.152 84.9224L134.252 66.5247L134.333 83.9746L102.226 102.535L102.152 84.9224Z"
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M102.145 12.9493L134.249 31.4833L102.151 49.8811L70.251 31.4833L102.146 12.9493H102.145Z"
      fill="#FFF8EF"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M102.152 49.8839L134.252 31.4861L134.333 56.187L102.226 74.7471L102.152 49.8839Z"
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M134.288 66.5007L102.154 84.9376L96.3359 81.5505L128.421 63.0759L134.288 66.5007Z"
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M108.631 60.8835L107.916 60.369L107.97 72.8434L108.683 73.3564L108.631 60.8835Z"
      fill="#F4F4F5"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M114.647 57.4027L113.932 56.8896L107.916 60.368L108.631 60.8825L114.647 57.4027Z"
      fill="white"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M114.702 69.8759L108.685 73.3557L108.632 60.8828L114.649 57.403L114.702 69.8759Z"
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M123.378 52.3923L122.664 51.8793L122.719 64.3551L123.43 64.8653L123.378 52.3923Z"
      fill="#F4F4F5"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M129.394 48.916L128.68 48.4044L122.664 51.8814L123.378 52.3944L129.394 48.916Z"
      fill="white"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M129.45 61.3877L123.433 64.8646L123.38 52.3917L129.397 48.9133L129.45 61.3877Z"
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M79.8604 16.1016L102.19 28.9788L102.219 43.7229L79.9169 30.6833L79.8604 16.1016Z"
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M102.191 28.9788L124.66 16.0986L124.716 30.7325L102.22 43.7228L102.187 28.9788H102.191Z"
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M102.19 28.979L79.8604 16.1017L102.187 3.12585L124.659 16.0988L102.19 28.979Z"
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <defs>
      <linearGradient
        id="paint0_linear_4444_1871"
        x1="54.0309"
        y1="133.135"
        x2="48.1524"
        y2="143.153"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.29" stopColor="#F5B3A4"></stop>
        <stop offset="0.75" stopColor="#F9D2C8"></stop>
        <stop offset="1" stopColor="#FBDED7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4444_1871"
        x1="152.289"
        y1="177.729"
        x2="151.786"
        y2="106.16"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.51" stopColor="#ED8B7D"></stop>
        <stop offset="1" stopColor="#EB7D74"></stop>
      </linearGradient>
    </defs>
  </svg>
);
